import { render } from "./PlansIconBox.vue?vue&type=template&id=1938a3a0&scoped=true&ts=true"
import script from "./PlansIconBox.vue?vue&type=script&lang=ts"
export * from "./PlansIconBox.vue?vue&type=script&lang=ts"

import "./PlansIconBox.vue?vue&type=style&index=0&id=1938a3a0&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1938a3a0"]])

export default __exports__